import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";
export const metadata: FigureMetadata = {
  id: "TOTBYSOURCE",
  title: defineMessage({
    id: "fig.finance.TOTBYSOURCE.title",
    defaultMessage: `Education spending by governments, households and donors`,
  }),
  caption: defineMessage({
    id: "fig.finance.TOTBYSOURCE.caption",
    defaultMessage: `Households are expected to contribute most to education funding where they can least afford to do so, and only a tiny fraction of global education spending goes to where the need is greatest.`,
  }),
  source: defineMessage({
    id: "fig.finance.TOTBYSOURCE.source",
    defaultMessage: `GEM Report team analysis based on the UIS (government and household) and OECD CRS (donor) databases`,
  }),
};
